var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"badge px-4 user-select-none",class:[_vm.type]},[(_vm.icon)?_c('i',{staticClass:"mr-1",class:[_vm.icon]}):_vm._e(),_vm._v(" "),_vm._t("icon"),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }